import type Router from "vue-router"
import {isSameRoute, routeRequiresPublishers} from "@/plugins/routerUtilities"
import Publishers from "@/managers/organization/publishers"
import {when} from "@/store/store"
import Notifications from "@/managers/session/notifications"
import Configuration from "@/managers/system/configuration"

export default function(router: Router): void {
	router.beforeResolve((to, from, next) => {
		if (isSameRoute(to, from) || !routeRequiresPublishers(to) || Publishers.isReady) {
			next()
			return
		}

		when(() => Publishers.isReady, Configuration.general.routerGuardTimeOut)
			.then(
				() => next(),
				reason => {
					Notifications.error("Failed to wait for publishers", reason)
					next({name: "notFound", params: {0: to.fullPath}})
				}
			)
	})
}
